import React from 'react'
import { tokens } from '../../styles/desertFloraTheme'

const styles = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: tokens.ink,
    minWidth: 140
  },
  select: {
    background: tokens.surface2,
    border: '1px solid ' + tokens.line2,
    borderRadius: 999,
    padding: '4px 28px 4px 10px',
    fontSize: 12.5,
    fontWeight: 500,
    color: tokens.ink,
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    backgroundImage: 'none',
    position: 'relative'
  }
}

const PillSelect = ({ options = [], value, onChange, label }) => {
  const [hover, setHover] = React.useState(false)
  const [focused, setFocused] = React.useState(false)

  const selectStyle = {
    ...styles.select,
    ...(hover && !focused ? { background: tokens.surface, borderColor: '#b8aa86' } : {}),
    ...(focused ? { background: tokens.primarySoft, borderColor: tokens.primary, color: tokens.primary } : {})
  }

  return (
    <div style={styles.container}>
      {label && <span style={styles.label}>{label}</span>}
      <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
        <select
          style={selectStyle}
          value={value ?? ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span
          style={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            fontSize: 11,
            color: focused ? tokens.primary : tokens.ink,
            lineHeight: 1
          }}
        >
          &#9662;
        </span>
      </span>
    </div>
  )
}

export default PillSelect
